import React from 'react';
import {FormularioEmpresa} from './FormularioEmpresa';
import {useNavigate} from 'react-router-dom';

export const ContentBodyRegistroEmpresa = () => {
	/* A hook that allows you to navigate between routes. */
	const navigate = useNavigate();

	return (
		<>
			<FormularioEmpresa
				registroEmpresa={true}
				atras={() => {
					navigate('/login');
				}}
			/>
		</>
	);
};
